import React, { useState, useEffect } from 'react';
import { Pause, Play, Square, SkipBack, SkipForward } from 'lucide-react';
import { Box, Typography, IconButton, Slider } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const PlaybackControls = ({ 
  onPause, 
  onResume, 
  onStop, 
  onSeek, 
  isPlaying, 
  duration, 
  currentTime 
}) => {
  const theme = useTheme();
  const [sliderValue, setSliderValue] = useState(0);

  useEffect(() => {
    setSliderValue(currentTime);
  }, [currentTime]);

  const handleSliderChange = (event, newValue) => {
    setSliderValue(newValue);
  };

  const handleSliderChangeCommitted = (event, newValue) => {
    onSeek(newValue);
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: theme.palette.background.playback,
      padding: '12px 20px',
      borderRadius: '6px',
      zIndex: 1,
      width: '80%',
      maxWidth: '400px'
    }}>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        width: '100%',
        mb: 1
      }}>
        <Typography variant="caption" color="white">
          {formatTime(currentTime)}
        </Typography>
        <Slider
          value={sliderValue}
          min={0}
          max={duration}
          onChange={handleSliderChange}
          onChangeCommitted={handleSliderChangeCommitted}
          sx={{
            color: 'white',
            '& .MuiSlider-thumb': {
              width: 12,
              height: 12,
            }
          }}
        />
        <Typography variant="caption" color="white">
          {formatTime(duration)}
        </Typography>
      </Box>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2
      }}>
        <IconButton 
          onClick={() => onSeek(Math.max(0, currentTime - 10))}
          sx={{ color: 'white' }}
        >
          <SkipBack size={20} />
        </IconButton>
        <IconButton 
          onClick={isPlaying ? onPause : onResume}
          sx={{ color: 'white' }}
        >
          {isPlaying ? <Pause size={24} /> : <Play size={24} />}
        </IconButton>
        <IconButton 
          onClick={onStop}
          sx={{ color: 'white' }}
        >
          <Square size={20} />
        </IconButton>
        <IconButton 
          onClick={() => onSeek(Math.min(duration, currentTime + 10))}
          sx={{ color: 'white' }}
        >
          <SkipForward size={20} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default PlaybackControls;